import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["baseClass", "baseClassActive", "className", "children", "innerRef", "style"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Transition } from "react-transition-group";
import { omit, pick, TransitionPropTypeKeys } from "./utils";

function O2Fade(props) {
  var baseClass = props.baseClass,
      baseClassActive = props.baseClassActive,
      className = props.className,
      children = props.children,
      innerRef = props.innerRef,
      style = props.style,
      otherProps = _objectWithoutPropertiesLoose(props, _excluded);

  var transitionProps = pick(otherProps, TransitionPropTypeKeys);
  var childProps = omit(otherProps, TransitionPropTypeKeys);
  var defaultStyle = {
    transition: "opacity " + props.timeout + "ms ease-in-out",
    opacity: 0
  };
  var transitionStyles = {
    entering: {
      opacity: 1
    },
    entered: {
      opacity: 1
    },
    exiting: {
      opacity: 0
    },
    exited: {
      opacity: 0
    }
  };
  return /*#__PURE__*/React.createElement(Transition, transitionProps, function (status) {
    var isActive = status === "entered";
    var classes = classNames(className, baseClass, isActive && baseClassActive);
    return /*#__PURE__*/React.createElement("div", _extends({
      className: classes
    }, childProps, {
      ref: innerRef,
      style: _objectSpread(_objectSpread(_objectSpread({}, defaultStyle), transitionStyles[status]), style)
    }), children);
  });
}

O2Fade.propTypes = _objectSpread(_objectSpread({}, Transition.propTypes), {}, {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  baseClass: PropTypes.string,
  baseClassActive: PropTypes.string,
  className: PropTypes.string,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.func])
});
O2Fade.defaultProps = _objectSpread(_objectSpread({}, Transition.defaultProps), {}, {
  baseClass: "fade",
  baseClassActive: "show",
  timeout: 150,
  appear: true,
  enter: true,
  exit: true,
  in: true
});
export default O2Fade;